import React from "react";
import Layout from "../../shared/Layout/Layout";
import leftArrow from "../../assets/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import Card from "../../components/_create_collection/Card/Card";
import styles from "./CreateCollection.module.scss";

const CreateCollection = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.leftArrow} onClick={() => navigate("/")}>
            <img src={leftArrow} alt="go-back" />
          </div>
          <h1>Create A New Collection</h1>

          <Card />
        </div>
      </div>
    </Layout>
  );
};

export default CreateCollection;
